<template>
    <div class="about-codex" v-if="pageSetup != null" id="codex">
        <div class="container">
            <div class="inner-content">
                <h2>{{ pageSetup.about_striv.title }}</h2>
                <div class="column-container">
                    <div class="col-left">
                        <strong v-html="pageSetup.about_striv.desc_left"></strong>
                    </div>
                    <div class="col-right">
                        <div class="desc"><p v-html="pageSetup.about_striv.desc_right"></p></div>
                    </div>
                </div>
                <div class="link-download-pdf" v-if="!isMobileChecker && pageSetup.about_striv.codex.file != false">
                    <img src="https://bcn.kz/cms/media/about_pdf.svg" alt="">
                    <a :href="pageSetup.about_striv.codex.file" download target="_blank">
                        <span>{{ pageSetup.about_striv.codex.name }}</span>
                        <svgIcon name="arrow-down" class="icon-arrow-down"/>
                    </a>
                </div>
                <div class="link-download-pdf link-download-pdf-mobile" v-if="isMobileChecker">
                    <a :href="pageSetup.about_striv.codex.file" download target="_blank">
                        <span>{{ pageSetup.about_striv.codex.name_mobile }}</span>
                        <img src="https://bcn.kz/cms/media/about_pdf.svg" alt="">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'about-codex-section',
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadAboutPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/about-codex.scss';
    @import '@/styles/components/about-page/respond/about-codex-respond.scss';
</style>